import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import * as Sentry from '@sentry/browser';
import { GetPropertyExternalReferencesDocument } from 'graphql-query-contracts';

export const usePropertyExternalReferences = (propertyId: string) => {
  const [getReferencesQueryFn, { loading, error, data }] = useLazyQuery(
    GetPropertyExternalReferencesDocument
  );

  const getReferences = useCallback(async () => {
    const { error } = await getReferencesQueryFn({
      variables: { propertyId },
    });

    if (error) {
      Sentry.captureException(error, {
        contexts: {
          params: {
            propertyId,
          },
        },
      });
    }
  }, [getReferencesQueryFn, propertyId]);

  return {
    references: data?.property?.externalReferences || [],
    isLoadingReferences: loading,
    getReferencesError: error,
    getReferences,
  };
};
